import { Engine1Proxy, ConciergeProxy } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';

export const GET_CUENTA_DATA = "GET_CUENTA_DATA";
export const GET_CUENTA_DATA_RESULT = "GET_CUENTA_DATA_RESULT";
export const GET_CUENTA_DATA_BY_PRODUCT = "GET_CUENTA_DATA_BY_PRODUCT";
export const RESET_STATE_ACCOUNT = "RESET_STATE_ACCOUNT ";
export const ROUTE_TO_NUEVA_SOLICITUD_CUENTA = "ROUTE_TO_NUEVA_SOLICITUD_CUENTA";
export const SELECT_COMBO = "SELECT_COMBO";
export const SET_ACCOUNT_FIELD = "SAVE_ACCOUNT_FIELD";
export const VALIDATE_ACCOUNT = "VALIDATE_ACCOUNT";
export const ACTUALIZAR_ESTADO_GLOBAL_NUEVA_CUENTA = "ACTUALIZAR_ESTADO_GLOBAL_NUEVA_CUENTA";
export const ACTUALIZAR_ESTADO_GLOBAL_CUENTA_SELECCIONADA = "ACTUALIZAR_ESTADO_GLOBAL_CUENTA_SELECCIONADA";
export const ELIMINAR_FUTURO_FROM_CUENTA = 'ELIMINAR_FUTURO_FROM_CUENTA';

let _tarjetas;
let _dispatch;
let _productoId = 0;
let _cuenta;
let _empresaSeleccionada;
let _cartera;
let userFunctions = [];
let userFeatures = [];

/**
 * 
 * @param {any} id
 * @param {any} currentScope
 * @param {any} cuenta
 */
export function GetScreenData(currentScope, id) {
    LogHelper.In(GetScreenData.name, currentScope, id);

    const { UserId, ProductCode, CategoryCode, ProgramCode } = currentScope;

    return (dispatch, getState) => {
        _tarjetas = JSON.parse(JSON.stringify(getState().tarjetas));
        _dispatch = dispatch;

        _empresaSeleccionada = _tarjetas.empresas.find((empresa) => {
            return empresa.seleccionada == true;
        });

        _cartera = _tarjetas.carteras.find((cartera) => {
            return cartera.Id == ((_empresaSeleccionada.cartera) ? _empresaSeleccionada.cartera.id : _empresaSeleccionada.CarteraId);
        });

        _cuenta = _tarjetas.cuentas.find((cuenta) => {
            return cuenta.Id == id;
        });

        dispatch({ type: GET_CUENTA_DATA, Id: id, Cartera: _cartera, EmpresaVisaId: _empresaSeleccionada.Id });

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadScreenData(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * 
 * @param {any} valor
 * @param {any} combo
 * @param {any} params
 */
export function seleccionarCombo(valor, combo, ...params) {
    LogHelper.In(seleccionarCombo.name, valor, combo);

    return (dispatch, getState) => {
        const state = getState();
        let Cuenta = state.cuenta.Cuenta;
        let validarPantalla = false;
        let validaciones = _validarCuenta(Cuenta, false);
        Object.keys(validaciones).forEach((ownProp) => {
            if (validaciones[ownProp] == false) {
                validarPantalla = true;
            }
        });
        dispatch({ type: SELECT_COMBO, valor, combo, params, validarPantalla });
    }
}

/**
 * 
 * @param {any} valor
 * @param {any} padre
 * @param {any} campo
 */
export function guardarCampoCuenta(valor, campo, ...params) {
    LogHelper.In(guardarCampoCuenta.name, valor, campo);

    return (dispatch, getState) => {
        const state = getState();
        let Cuenta = state.cuenta.Cuenta;
        let validarPantalla = false;
        let validaciones = _validarCuenta(Cuenta, false);
        Object.keys(validaciones).forEach((ownProp) => {
            if (validaciones[ownProp] == false) {
                validarPantalla = true;
            }
        });

        dispatch({ type: SET_ACCOUNT_FIELD, valor, campo, params, validarPantalla });
    }
}

/** 
 * Action que valida el nombre de la cuenta que no sea el mismo que otro.
 */
export function validarCuenta() {
    LogHelper.In(validarCuenta.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        const state = getState();

        let localValue = {
            'CLIENTE_ID': state.tarjetas.cliente.Id,
            'DESCRIPCION': state.cuenta.Cuenta.CuentaDenominacion ? state.cuenta.Cuenta.CuentaDenominacion : ''
        }

        LogHelper.Out(validarCuenta.name, localValue, 'GET_NOMBRE_CUENTA_REPETIDO', "Get", 'Tarjetas', 'CONSULTASOCIOS', 1, "Product");
        Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_NOMBRE_CUENTA_REPETIDO', "Get", 'Tarjetas', 'CONSULTASOCIOS', 1, "Product");
        Engine1Proxy.Execute((data) => _loadValidarCuenta(data, state), null, null, "CONSULTASOCIOS");
    }
}

/**
 * 
 * @param {any} data
 * @param {any} state
 */
function _loadValidarCuenta(data, state) {
    LogHelper.In(_loadValidarCuenta.name, data, state);

    let esNombreCuentaRepetido = JSON.parse(data.GET_NOMBRE_CUENTA_REPETIDO).Recordset0.Rows[0].EsNombreRepetido;

    let Cuenta = state.cuenta.Cuenta;
    Cuenta.EsNombreCuentaRepetido = esNombreCuentaRepetido;
    let validarPantalla = false;
    let validaciones = _validarCuenta(Cuenta, false);

    Object.keys(validaciones).forEach((ownProp) => {
        if (validaciones[ownProp] == false) {
            validarPantalla = true;
        }
    });

    if (validarPantalla == false) {
        if (Cuenta.DomicilioCorrespondenciaCodigoGeografico == "0") {
            Cuenta.DomicilioCorrespondenciaCodigoGeografico = Cuenta.DomicilioCorrespondenciaCodigoGeograficoInput;
        }

        if (Cuenta.DomicilioParticularCodigoGeografico == "0") {
            Cuenta.DomicilioParticularCodigoGeografico = Cuenta.DomicilioParticularCodigoGeograficoInput;
        }

        delete Cuenta.DomicilioCorrespondenciaCodigoGeograficoInput;
        delete Cuenta.DomicilioParticularCodigoGeograficoInput;

        if (Cuenta.esNueva == true) {
            Cuenta.Id = -1;
        }

        if (Cuenta.LimiteDefaultTarjetas == "") {
            delete Cuenta.LimiteDefaultTarjetas;
        }

        if (Cuenta.EsDebitoEnCuenta == false) {
            delete Cuenta.FormaDebitoId;
            delete Cuenta.CuentaBancariaSucursalId;
            delete Cuenta.CuentaBancariaNumero;
        }

        Cuenta.CantTarjetasCredito = 0;

        _dispatch({ type: ACTUALIZAR_ESTADO_GLOBAL_NUEVA_CUENTA, cuenta: Cuenta });        
        _dispatch({ type: ROUTE_TO_NUEVA_SOLICITUD_CUENTA });
        

        //Elimino el futuro si hay tarjetas nuevas para una cuenta y se agrega una nueva.
        if (_tarjetas.tarjetas != undefined) {
            let empresa = state.tarjetas.empresas.find(x => x.Id == Cuenta.EmpresaId);
            let tcs = _tarjetas.tarjetas.filter(x => x.CuentaTarjetaId == Cuenta.Id);
            empresa.TARJETAS -= tcs.length;
            if (_tarjetas.tarjetas.find(x => x.esNueva == true) != undefined)
                _dispatch({ type: ELIMINAR_FUTURO_FROM_CUENTA });
        }
    } else {
        _dispatch({ type: VALIDATE_ACCOUNT, validarPantalla, validaciones });
    }
}
/**
 * 
 */
export function cancelar() {
    LogHelper.In(cancelar.name);

    return (dispatch) => {
        dispatch({ type: ROUTE_TO_NUEVA_SOLICITUD_CUENTA });
        dispatch({ type: ACTUALIZAR_ESTADO_GLOBAL_CUENTA_SELECCIONADA, id: ((_cuenta) ? _cuenta.Id : 0) });
    }
}

/**
 * 
 */
export function reiniciarEstado() {
    LogHelper.In(reiniciarEstado.name);

    return (dispatch, getState) => {
        dispatch({ type: RESET_STATE_ACCOUNT });
    }
}

/**
 * 
 * @param {any} id
 */
export function selectComboProducto(id) {
    LogHelper.In(selectComboProducto.name, id);

    return (dispatch, getState) => {
        const valor = id;
        const combo = "PRODUCTOS";

        _productoId = id;
        dispatch({ type: SELECT_COMBO, valor, combo });
        _ejecutarDataSourceNuevaCuenta((id != 0), _loadProductData);
    }
}

/* -------------------------------------------- FUNCIONES AUXILIARES -------------------------------------------- */
/**
 * 
 * @param {any} data
 */
function _loadScreenData(data) {
    LogHelper.In(_loadScreenData.name, data);

    userFeatures = JSON.parse(JSON.stringify(data)); //Todos los permisos por feature del usuario en el programa.
    userFunctions = JSON.parse(JSON.stringify(data.SOLICITUD)); //Permisos del usuario para la feature a utilizar.

    if (_cuenta) {
        _productoId = _cuenta.ProductoId;
    }
    _ejecutarDataSourceNuevaCuenta((_cuenta != undefined), _loadNewAccountData)
}

/**
 * 
 * @param {any} data
 */
function _loadNewAccountData(data) {
    LogHelper.In(_loadNewAccountData.name, data);

    data.errorEnWebService = false;
    data.GET_TODOS_DOMICILIOS_ITAU = [];
    data.GET_LISTAR_POR_DOCUMENTO_ITAU = [];
    data.GET_DOCUMENTO = undefined;

    data.GET_PRODUCTOS = data.GET_PRODUCTOS.filter((producto) => {
        return (producto.EstaHabilitado == true &&
            producto.ProductoVisaId != undefined)
    });

    if (_cuenta) {
        let producto = data.GET_PRODUCTOS.find((p) => p.Id == _cuenta.ProductoId);
        _cuenta.ProductoId = (producto) ? producto.Id : 0;

        //Si no existe, entonces lo ingresó el usuario manualmente
        if (!data.GET_CODIGO_GEOGRAFICO.find((codigo) => codigo.CodigoGeografico == _cuenta.DomicilioCorrespondenciaCodigoGeografico)) {
            _cuenta.DomicilioCorrespondenciaCodigoGeograficoInput = _cuenta.DomicilioCorrespondenciaCodigoGeografico;
            _cuenta.DomicilioCorrespondenciaCodigoGeografico = "0"
        }

        //Si no existe, entonces lo ingreso el usuario manualmente
        if (!data.GET_CODIGO_GEOGRAFICO.find((codigo) => codigo.CodigoGeografico == _cuenta.DomicilioParticularCodigoGeografico)) {
            _cuenta.DomicilioParticularCodigoGeograficoInput = _cuenta.DomicilioParticularCodigoGeografico;
            _cuenta.DomicilioParticularCodigoGeografico = "0"
        }

        let formaPago = data.GET_FORMA_PAGO.find((formaPago) => formaPago.Id == _cuenta.FormaPagoId);
        _cuenta.EsDebitoEnCuenta = (formaPago) ? formaPago.EsDebitoEnCuenta : false;

        let promotor = data.GET_PROMOTOR.find((promotor) => promotor.Id == _cuenta.PromotorId);
        _cuenta.Promotor = (promotor) ? promotor.Nombre : "";
    }

    //Utiliza los Domicilios
    _tarjetas.cliente.Domicilios.forEach(function (row) {
        if (row.Direccion.CodigoDomicilio == "01") {
            row.Direccion.CodigoPostal = row.Direccion.CodigoPostal.slice(0, 4);
            data.GET_DOMICILIOS_ITAU = row;
        }

        data.GET_TODOS_DOMICILIOS_ITAU.push(row);
    });

    //Utiliza la Lista de Documentos
    let sucursalesCuentas = [];
    data.GET_LISTAR_POR_DOCUMENTO_ITAU = data.GETCLIENTELISTADOCUMENTOS;

    data.GET_LISTAR_POR_DOCUMENTO_ITAU.forEach((cuenta, index) => {
        let sucursal = data.GET_SUCURSAL.find((sucursal) => sucursal.Codigo == cuenta.Cuenta.Sucursal);
        let resultado = sucursalesCuentas.some((sc) => sc.Codigo == cuenta.Cuenta.Sucursal);

        if (!resultado) {
            sucursalesCuentas.push({
                Id: (sucursal) ? sucursal.Id : index,
                Codigo: cuenta.Cuenta.Sucursal,
                Descripcion: (sucursal) ? sucursal.Descripcion : ""
            });
        }
    });

    //Realizo dispatch
    data = {
        ...data,
        GET_SUCURSAL_CUENTA: sucursalesCuentas,
    }

    _dispatch({ type: GET_CUENTA_DATA_RESULT, data: data, cuenta: _cuenta });
}

/**
 * 
 * @param {any} data
 */
function _loadProductData(data) {
    LogHelper.In(_loadProductData.name, data);

    data.GET_PRODUCTOS = data.GET_PRODUCTOS.filter((producto) => {
        return (producto.EstaHabilitado == true &&
            producto.ProductoVisaId != undefined)
    });

    let producto = data.GET_PRODUCTOS.find((producto) => producto.Id == _productoId);
    let productoVisa = data.GET_PRODUCTO_VISA.find((producto) => producto.ProductoId == _productoId);
    //En caso de que sea "Seleccione"
    producto = (producto) ? producto : {};
    productoVisa = (productoVisa) ? productoVisa : { FlccEsModificable: true, LimiteFinanciacionEsModificable: true };

    let modeloLiquidacionId = (producto.DefaultModeloLiquidacionId) ? producto.DefaultModeloLiquidacionId : 0;
    let modeloLiquidacion = data.GET_MODELO_LIQUIDACION.find((modelo) => modelo.Id == modeloLiquidacionId);
    let grupoAfinidadId = (producto.DefaultGrupoAfinidadId) ? producto.DefaultGrupoAfinidadId : 0;
    let grupoAfinidad = data.GET_GRUPO_AFINIDAD.find((grupo) => grupo.Id == grupoAfinidadId);
    let formaPagoId = (producto.DefaultFormaPagoId) ? producto.DefaultFormaPagoId : 0;
    let formaPago = data.GET_FORMA_PAGO.find((forma) => forma.Id == formaPagoId);
    let lineaPrestamoVisaId = (productoVisa.DefaultLineaPrestamoId) ? productoVisa.DefaultLineaPrestamoId : undefined;
    let lineaPrestamoVisa = data.GET_LINEA_PRESTAMO.find((prestamo) => prestamo.Id == lineaPrestamoVisaId);
    let categoriaCajeroVisaId = (productoVisa.DefaultCategoriaAtmId) ? productoVisa.DefaultCategoriaAtmId : 0;
    let categoriaCajeroVisa = data.GET_CATEGORIA_CAJERO.find((atm) => atm.Id == categoriaCajeroVisaId);

    let resultado = {
        /*Datos del datasource*/
        ...data,
        Cuenta: {
            ..._cuenta,
            /*Propiedades de cuenta*/
            SucursalId: 0,
            LimiteCompraId: 0,
            LimiteCompraCodigo: undefined,
            /*Producto*/
            ProductoId: _productoId,
            ModeloLiquidacionId: modeloLiquidacionId,
            ModeloLiquidacionCodigo: (modeloLiquidacion) ? modeloLiquidacion.Codigo : undefined,
            GrupoAfinidadId: grupoAfinidadId,
            GrupoAfinidadCodigo: (grupoAfinidad) ? grupoAfinidad.Codigo : undefined,
            FormaPagoId: formaPagoId,
            FormaPagoCodigo: (formaPago) ? formaPago.Codigo : undefined,
            EsDebitoEnCuenta: (formaPago) ? formaPago.EsDebitoEnCuenta : false,
            FormaDebitoId: (producto.DefaultFormaDebitoId) ? producto.DefaultFormaDebitoId : 0,
            CuentaBancariaSucursalId: 0,
            CuentaBancariaSucursalCodigo: undefined,
            CuentaBancariaNumero: undefined,
            /*Producto Visa*/
            ModalidadDistribucionLimiteId: productoVisa.DefaultModalidadDistribucionLimiteId,
            AgrupamientoVisaId: productoVisa.DefaultAgrupamientoId,
            LimiteFinanciacion: (productoVisa.LimiteFinanciacion) ? productoVisa.LimiteFinanciacion : "",
            Flcc: (productoVisa.Flcc) ? productoVisa.Flcc : "",
            LimiteFinanciacionEsModificable: productoVisa.LimiteFinanciacionEsModificable,
            FlccEsModificable: productoVisa.FlccEsModificable,
            LineaPrestamoVisaId: lineaPrestamoVisaId,
            LineaPrestamoVisaCodigo: (lineaPrestamoVisa) ? lineaPrestamoVisa.Codigo : undefined,
            CategoriaCajeroVisaId: categoriaCajeroVisaId,
            CategoriaCajeroVisaCodigo: (categoriaCajeroVisa) ? categoriaCajeroVisa.Codigo : undefined,
        }
    }

    let validaciones = _validarCuenta(resultado.Cuenta, true);
    _dispatch({ type: GET_CUENTA_DATA_BY_PRODUCT, data: resultado, validaciones });
}

/**
 * 
 * @param {any} cuenta
 * @param {any} esPorCambioDeProducto
 */
function _validarCuenta(cuenta, esPorCambioDeProducto) {
    LogHelper.In(_validarCuenta.name, cuenta, esPorCambioDeProducto);

    let validaciones = {};

    if (esPorCambioDeProducto) {
        validaciones.ProductoSeleccionado = true;
    } else {
        validaciones.ProductoSeleccionado = (cuenta.ProductoId != 0 && cuenta.ProductoId != undefined);
    }
    validaciones.CuentaDenominacionSeleccionada = (cuenta.CuentaDenominacion != "" && cuenta.CuentaDenominacion != undefined);
    validaciones.CuentaDenominacionRepetida = ((cuenta.EsNombreCuentaRepetido == 0 || cuenta.EsNombreCuentaRepetido == undefined) ? true : false)
    validaciones.DescripcionSeleccionada = (cuenta.Descripcion != "" && cuenta.Descripcion != undefined);
    validaciones.PlantaSeleccionada = (cuenta.Planta != "" && cuenta.Planta != undefined);
    validaciones.SucursalSeleccionada = (cuenta.SucursalId != 0 && cuenta.SucursalId != undefined);
    validaciones.ModeloLiquidacionSeleccionado = (cuenta.ModeloLiquidacionId != 0 && cuenta.ModeloLiquidacionId != undefined);
    validaciones.GrupoAfinidadSeleccionado = (cuenta.GrupoAfinidadId != 0 && cuenta.GrupoAfinidadId != undefined);
    validaciones.LimiteCompraSeleccionado = (cuenta.LimiteCompraId != 0 && cuenta.LimiteCompraId != undefined);
    validaciones.ModalidadDistribucionLimiteSeleccionada = (cuenta.ModalidadDistribucionLimiteId != 0 && cuenta.ModalidadDistribucionLimiteId != undefined);
    validaciones.AgrupamientoSeleccionado = (cuenta.AgrupamientoVisaId != 0 && cuenta.AgrupamientoVisaId != undefined);
    validaciones.FormaPagoSeleccionada = (cuenta.FormaPagoId != 0 && cuenta.FormaPagoId != undefined);
    validaciones.FormaDebitoSeleccionada = (cuenta.EsDebitoEnCuenta == true) ? (cuenta.FormaDebitoId != 0 && cuenta.FormaDebitoId != undefined) : true;
    validaciones.CuentaBancariaSucursalSeleccionada = (cuenta.EsDebitoEnCuenta == true) ? (cuenta.CuentaBancariaSucursalId != -1 && cuenta.CuentaBancariaSucursalId != undefined) : true;
    validaciones.CuentaBancariaNumeroSeleccionada = (cuenta.EsDebitoEnCuenta == true) ? (cuenta.CuentaBancariaNumero != 0 && cuenta.CuentaBancariaNumero != undefined) : true;

    validaciones.FlccSeleccionado = new RegExp(/^(?=.*[1-9])\d{0,2}(?:\.\d{0,1})?$/).test(cuenta.Flcc);

    validaciones.CodigoDomicilioSeleccionado = (cuenta.DomicilioCorrespondenciaBancoTipo != 0 && cuenta.DomicilioCorrespondenciaBancoTipo != undefined);

    if (cuenta.DomicilioCorrespondenciaCodigoGeografico && cuenta.DomicilioCorrespondenciaCodigoGeografico == "0") {
        validaciones.CodigoGeograficoSeleccionado = (cuenta.DomicilioCorrespondenciaCodigoGeograficoInput != "");
    } else {
        validaciones.CodigoGeograficoSeleccionado = (cuenta.DomicilioCorrespondenciaCodigoGeografico != "" && cuenta.DomicilioCorrespondenciaCodigoGeografico != undefined);
    }

    if (cuenta.DomicilioParticularCodigoGeografico && cuenta.DomicilioParticularCodigoGeografico == "0") {
        validaciones.CodigoGeograficoParticularSeleccionado = (cuenta.DomicilioParticularCodigoGeograficoInput != "");
    } else {
        validaciones.CodigoGeograficoParticularSeleccionado = (cuenta.DomicilioParticularCodigoGeografico != "" && cuenta.DomicilioParticularCodigoGeografico != undefined);
    }

    validaciones.PromotorSeleccionado = (cuenta.PromotorId != 0 && cuenta.PromotorId != undefined);
    validaciones.CategoriaSeleccionada = (cuenta.CategoriaCajeroVisaId != 0 && cuenta.CategoriaCajeroVisaId != undefined);

    return validaciones;
}

/**
 * 
 * @param {any} cambioElProducto
 * @param {any} callback
 */
function _ejecutarDataSourceNuevaCuenta(cambioElProducto, callback) {
    LogHelper.In(_ejecutarDataSourceNuevaCuenta.name, cambioElProducto, callback);

    const tipoEmpresaId = _tarjetas.tipoEmpresa.find((te) => te.seleccionada == true).Id;
    const paramProducto = { "PRODUCTO_ID": parseInt(_productoId) }
    const paramAdm = { 'ADMINISTRADORA_ID': parseInt(_tarjetas.administradora.Id) }
    const paramGetProductos = {
        "ADMINISTRADORA_ID": parseInt(_tarjetas.administradora.Id), "CARTERA_ID": parseInt(_cartera.Id), "TIPO_EMPRESA_ID": tipoEmpresaId
    }

    const parametroListaDocumentos = {
        'NUMERO_DOCUMENTO': _tarjetas.cliente.NumeroDocumento,
        'TIPO_DOCUMENTO_CODIGO': _tarjetas.cliente.TipoDocumento.Codigo
    }

    const paramSuCuentas = {
        "PRODUCTO_ID": parseInt(_productoId),
        'NUMERO_DOCUMENTO': _tarjetas.cliente.NumeroDocumento,
        'TIPO_DOCUMENTO_CODIGO': _tarjetas.cliente.TipoDocumento.Codigo
    }

    if (cambioElProducto) {
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_SUCURSAL_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_SUCURSAL_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_LIMITE_COMPRA_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_LIMITE_COMPRA_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_MODELO_LIQUIDACION_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_MODELO_LIQUIDACION_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_GRUPO_AFINIDAD_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_GRUPO_AFINIDAD_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_VISA_AGRUPAMIENTO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_VISA_AGRUPAMIENTO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_VISA_CATEGORIA_ATM_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_VISA_CATEGORIA_ATM_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_VISA_LINEA_PRESTAMO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_VISA_LINEA_PRESTAMO_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_VISA_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_VISA_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID', 'Get', 'Tarjetas', 'ADMINPRODUCTOS', 1, 'Product');
    } else {
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, null, 'GET_SUCURSAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_SUCURSAL', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramAdm, 'GET_LIMITE_COMPRA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramAdm, 'GET_LIMITE_COMPRA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, null, 'GET_FORMA_DEBITO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_FORMA_DEBITO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, null, 'GET_FORMA_PAGO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_FORMA_PAGO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramAdm, 'GET_MODELO_LIQUIDACION_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramAdm, 'GET_MODELO_LIQUIDACION_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramAdm, 'GET_GRUPO_AFINIDAD_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramAdm, 'GET_GRUPO_AFINIDAD_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, null, 'GET_AGRUPAMIENTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_AGRUPAMIENTO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, null, 'GET_CATEGORIA_CAJERO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_CATEGORIA_CAJERO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, null, 'GET_LINEA_PRESTAMO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_LINEA_PRESTAMO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, null, 'GET_MODALIDAD_DISTRIBUCION_LIMITE', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_MODALIDAD_DISTRIBUCION_LIMITE', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    }

    LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramGetProductos, 'GET_PRODUCTOS_ADMINISTRADORA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramGetProductos, 'GET_PRODUCTOS_ADMINISTRADORA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
    LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramProducto, 'GET_PRODUCTO_VISA_PRODUCTO_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(paramProducto, 'GET_PRODUCTO_VISA_PRODUCTO_ID', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, null, 'GET_PROMOTOR', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_PROMOTOR', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, null, 'GET_CODIGO_GEOGRAFICO_VISA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    Engine1Proxy.AddDataSourcesRequests(null, 'GET_CODIGO_GEOGRAFICO_VISA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, parametroListaDocumentos, 'GETCLIENTELISTADOCUMENTOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametroListaDocumentos, 'GETCLIENTELISTADOCUMENTOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    LogHelper.Out(_ejecutarDataSourceNuevaCuenta.name, paramSuCuentas, 'GETCLIENTESUCURSALES', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(paramSuCuentas, 'GETCLIENTESUCURSALES', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

    Engine1Proxy.Execute((data) => _mapeadorDataSources(data, cambioElProducto, callback), null, null, "SOLICITUD");
}

/**
 * 
 * @param {any} data
 * @param {any} cambioProducto
 * @param {any} callback
 */
function _mapeadorDataSources(data, cambioProducto, callback) {
    LogHelper.In(_mapeadorDataSources.name, data, cambioProducto, callback);

    let result = {
        "GET_PRODUCTOS": JSON.parse(data.GET_PRODUCTOS_ADMINISTRADORA).Recordset0.Rows,
        "GET_SUCURSAL": (data.GET_SUCURSAL != undefined ? JSON.parse(data.GET_SUCURSAL).Recordset0.Rows : JSON.parse(data.GETCLIENTESUCURSALES)),
        "GET_LIMITE_COMPRA": JSON.parse(data.GET_LIMITE_COMPRA || data.GET_PRODUCTO_LIMITE_COMPRA_PRODUCTO_ID).Recordset0.Rows,
        "GET_MODELO_LIQUIDACION": JSON.parse(data.GET_MODELO_LIQUIDACION_ADMINISTRADORA || data.GET_PRODUCTO_MODELO_LIQUIDACION_PRODUCTO_ID).Recordset0.Rows,
        "GET_GRUPO_AFINIDAD": JSON.parse(data.GET_GRUPO_AFINIDAD_ADMINISTRADORA || data.GET_PRODUCTO_GRUPO_AFINIDAD_PRODUCTO_ID).Recordset0.Rows,
        "GET_MODALIDAD_DISTRIBUCION_LIMITE": JSON.parse(data.GET_MODALIDAD_DISTRIBUCION_LIMITE || data.GET_PRODUCTO_VISA_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID).Recordset0.Rows,
        "GET_AGRUPAMIENTO": JSON.parse(data.GET_AGRUPAMIENTO || data.GET_PRODUCTO_VISA_AGRUPAMIENTO_PRODUCTO_ID).Recordset0.Rows,
        "GET_LINEA_PRESTAMO": JSON.parse(data.GET_LINEA_PRESTAMO || data.GET_PRODUCTO_VISA_LINEA_PRESTAMO_PRODUCTO_ID).Recordset0.Rows,
        "GET_FORMA_PAGO": JSON.parse(data.GET_FORMA_PAGO || data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID).Recordset0.Rows,
        "GET_FORMA_DEBITO": JSON.parse(data.GET_FORMA_DEBITO || data.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID).Recordset0.Rows,
        "GET_CATEGORIA_CAJERO": JSON.parse(data.GET_CATEGORIA_CAJERO || data.GET_PRODUCTO_VISA_CATEGORIA_ATM_PRODUCTO_ID).Recordset0.Rows,
        "GET_PROMOTOR": JSON.parse(data.GET_PROMOTOR).Recordset0.Rows,
        "GET_CODIGO_GEOGRAFICO": JSON.parse(data.GET_CODIGO_GEOGRAFICO_VISA).Recordset0.Rows,
        "GET_PRODUCTO_VISA": JSON.parse(data.GET_PRODUCTO_VISA_PRODUCTO_ID).Recordset0.Rows,
        "GET_LISTAR_POR_DOCUMENTO_WEB_SERVICES": [],
        "GET_DOMICILIOS_WEB_SERVICES": [],
        "GETCLIENTELISTADOCUMENTOS": JSON.parse(data.GETCLIENTELISTADOCUMENTOS),
        "GETCLIENTESUCURSALES": JSON.parse(data.GETCLIENTESUCURSALES)
    }

    callback(result);
}


// WEBPACK FOOTER //
// ./Portico/Productos/Tarjetas/App/Screens/Cuenta/actions/Actions.js